import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../store/reportStore'
import { connect } from 'react-redux';
import { isOnPath, hasPermission } from '../../store/apiWrapper';
import CrossIcon from '../../img/icons/Cross';
import classnames from "classnames";
import EgSettings from './settings/EgSettings';
import Legend from '../common/legendComponent';

class ReportSettings extends React.Component {
    _settings = [
        {
            id:'economic-group', visible:() => isOnPath({ regex: /report\/economic-group/i}),
            body:EgSettings, subtitle: hasPermission(null, 'EconomicGroupSberbankMethodology') ? 'Report.Ess.SberbankMethodology' : 'Report.EconomicGroup.Settings.Title', order:0,
        }
    ]

    state = {
        collapse: []
    }

    UNSAFE_componentWillMount() {
        const newState = { ...this.state };
        for (let i = 0; i < this._settings.length; i++) {
            newState.collapse[this._settings[i].id] = true;
        }
        this.setState(newState);
    }

    render() {
        let items = this.getVisibleItems();
        const hasLegend = items.length > 0 && items[0].legend !== undefined && items[0].legend !== null;
        return (
            <article className="panel">
                <div className="panel-heading">
                    <div className='panel-heading-title'>
                        <div style={{marginRight:'auto', marginTop:'auto', marginBottom:'auto'}}><Translate id='Report.Settings.Title' /></div>
                        {hasLegend && this[items[0].legend].call(this, this.props.translate)}
                        <CrossIcon className='icon-centered' onClick={this.props.closePanel} style={{marginLeft: '.5em'}} />
                    </div>
                    {items.length > 0 && items[0].subtitle !== undefined && items[0].subtitle !== null && <div className='panel-heading-subtitle'><Translate id={items[0].subtitle} /></div>}
                </div>
                <div className={classnames({'search-progress': true, 'searching': this.props.isLoading})}></div>
                <div className="panel-block">
                    {this.renderContent(items)}
                </div>
            </article>
        );
    }

    renderContent = (items) => {
        return (
            items.map(x => {
                const Body = x.body;
                return <Body expanded={this.state.collapse[x.id]} togglePanel={() => this.toggle(x.id)} />
            })
        );
    }

    toggle = (id) => {
        const newState = { ...this.state };
        newState.collapse[id] = !this.state.collapse[id];
        this.setState(newState);
    }

    getVisibleItems = () => {
        return this._settings.filter(r => r.visible() && r.body !== null && r.body !== undefined);
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(ReportSettings));